import React from 'react';

/** Paragraph block — single body paragraph. data: { text } */
export default function Paragraph({ data = {} }) {
  const { text = '' } = data;
  if (!text) return null;
  return (
    <section data-testid="site-block-paragraph">
      <div className="max-w-3xl mx-auto px-6 py-4">
        <p className="text-base lg:text-lg orka-text-secondary leading-relaxed">{text}</p>
      </div>
    </section>
  );
}
